import script from "./BankbookReportsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankbookReportsModal.vue?vue&type=script&setup=true&lang=ts"

import "./BankbookReportsModal.vue?vue&type=style&index=0&id=6efe23dc&lang=scss"

const __exports__ = script;

export default __exports__